import * as z from 'zod';

import { schema } from '.';
import { validaSchema } from './validaSchema';
import { validateDuplicateCPFs } from '../../../../utils/validateUniqueCpf';

export const debitSchema = z
  .object({
    payment: z.optional(
      z.object({
        firstPaymentBillet: z.optional(z.boolean()),
        bank: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
        operation: z.optional(
          z.string().min(1, { message: 'Campo obrigatório' }),
        ),
        billetDate: z.optional(z.string()),
        debitDate: z.optional(z.string()),
        agency: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
        debitAcount: z.optional(
          z.string().min(1, { message: 'Campo obrigatório' }),
        ),
      }),
    ),

    user: schema,
    valida: validaSchema,
  })
  .superRefine((data, ctx) => {
    const entries: { cpf?: string; path: (string | number)[] }[] = [];
    const firstPaymentBillet = data.payment?.firstPaymentBillet;
    const billetDate = data.payment?.billetDate?.trim();
    const debitDate = data.payment?.debitDate?.trim();

    const user = data.user || {};

    if (firstPaymentBillet && !billetDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
        path: ['payment', 'billetDate'],
      });
    }

    if (!firstPaymentBillet && !debitDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
        path: ['payment', 'debitDate'],
      });
    }

    if (user.documents?.cpf) {
      entries.push({
        cpf: user.documents.cpf,
        path: ['user', 'documents', 'cpf'],
      });
    }

    (user.dependents || []).forEach((dep, i) => {
      entries.push({
        cpf: dep.cpf,
        path: ['user', 'dependents', i, 'cpf'],
      });
    });

    validateDuplicateCPFs(entries, ctx);
  });

export type DebitSchema = z.infer<typeof debitSchema>;
